// The KPI cards of the Digital Receipt dashboard, as data.
//
// Four cards: the fourth, dropped in CHA1-3169 as "Dispute amount prevented", is back as "Average
// volume" (CHA1-4325), the mean dollar value of a lookup as on Deflect Analytics (CHA1-4441). One
// definition serves
// every surface -- merchant page, admin mirror, Demo, External Demo, Light, Incognito and the
// enrollment-in-progress overlay all render the same component from the same API payload -- so a
// card added or removed here changes it everywhere.
//
// Kept out of the component so the card set can be tested with the built-in Node runner (this repo
// installs no test framework); see `__tests__/kpiCards.test.js`.

// `accounting` is CommonJS. A default import is what both Vite and Node resolve; the named form
// only works through Vite's interop and would keep this module out of the Node test runner.
import accounting from "accounting"

const { formatNumber } = accounting

export const formatCurrency = (v) => "$" + formatNumber(v ?? 0, 2, ",")

/**
 * Build the card list for one KPI payload, in display order.
 *
 * @param {{bankInquiries?: number, matchRate?: number, lookupFees?: number, averageVolume?: number}} [kpi]
 * @returns {{key: string, label: string, subtitle: string, value: string}[]}
 */
export const buildKpiCards = (kpi) => [
  {
    key: "bank_inquiries",
    label: "Bank inquiries",
    subtitle: "Inquiries received from banks",
    value: formatNumber(kpi?.bankInquiries ?? 0, 0, ",")
  },
  {
    key: "match_rate",
    label: "Match rate",
    subtitle: "Inquiries with order matches",
    value: `${(kpi?.matchRate ?? 0).toFixed(1)}%`
  },
  {
    key: "lookup_fees",
    label: "Lookup fees",
    subtitle: "Fees charged to your balance",
    value: formatCurrency(kpi?.lookupFees)
  },
  {
    key: "average_volume",
    label: "Average volume",
    subtitle: "Disputes avoided post-lookup",
    value: formatCurrency(kpi?.averageVolume)
  }
]
